import { StyleSheet } from 'react-native';

import { DashboardScope } from '@api/domain/types';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

import { RankBadgeVariant, type Rank, type RankBadgeStyle } from '@v2/pages/dashboard/common/types/rows';
import { isPhone } from '@helpers';

export const DASHBOARD_OVERVIEW_BOTTOM_BLOCK_PAGE_SIZE = 5;

const OPACITY = {
  full: 1,
  medium: 0.65,
  low: 0.38,
};

export const RANK_BADGE_COLORS: Record<RankBadgeVariant, Record<Rank, RankBadgeStyle>> = {
  [RankBadgeVariant.Worst]: {
    1: { color: 'System/Light/Red', opacity: OPACITY.full },
    2: { color: 'System/Light/Orange', opacity: OPACITY.full },
    3: { color: 'System/Light/Orange', opacity: OPACITY.low },
    4: { color: 'System/Light/Orange', opacity: OPACITY.low },
    5: { color: 'System/Light/Orange', opacity: OPACITY.low },
  },
  [RankBadgeVariant.Best]: {
    1: { color: 'System/Light/Green', opacity: OPACITY.full },
    2: { color: 'System/Light/Green', opacity: OPACITY.medium },
    3: { color: 'System/Light/Green', opacity: OPACITY.low },
    4: { color: 'System/Light/Green', opacity: OPACITY.low },
    5: { color: 'System/Light/Green', opacity: OPACITY.low },
  },
  [RankBadgeVariant.Actual]: {
    1: { color: 'System/Light/Blue', opacity: OPACITY.full },
    2: { color: 'System/Light/Blue', opacity: OPACITY.medium },
    3: { color: 'System/Light/Blue', opacity: OPACITY.low },
    4: { color: 'System/Light/Blue', opacity: OPACITY.low },
    5: { color: 'System/Light/Blue', opacity: OPACITY.low },
  },
};

export const PANEL_TITLE_BY_SCOPE: Record<DashboardScope, Record<RankBadgeVariant, string>> = {
  [DashboardScope.Machine]: {
    [RankBadgeVariant.Worst]: 'Worst Machines',
    [RankBadgeVariant.Best]: 'Best Machines',
    [RankBadgeVariant.Actual]: 'Machines',
  },
  [DashboardScope.Customer]: {
    [RankBadgeVariant.Worst]: 'Worst Customers',
    [RankBadgeVariant.Best]: 'Best Customers',
    [RankBadgeVariant.Actual]: 'Customers',
  },
  [DashboardScope.Part]: {
    [RankBadgeVariant.Worst]: 'Worst Parts',
    [RankBadgeVariant.Best]: 'Best Parts',
    [RankBadgeVariant.Actual]: 'Parts',
  },
  [DashboardScope.NcFile]: {
    [RankBadgeVariant.Worst]: 'Worst NC Files',
    [RankBadgeVariant.Best]: 'Best NC Files',
    [RankBadgeVariant.Actual]: 'NC Files',
  },
};

export const PANEL_TEST_ID_BY_VARIANT: Record<RankBadgeVariant, string> = {
  [RankBadgeVariant.Worst]: TEST_IDS.dashboardOverviewBottomBlock.worstPanel,
  [RankBadgeVariant.Best]: TEST_IDS.dashboardOverviewBottomBlock.bestPanel,
  [RankBadgeVariant.Actual]: TEST_IDS.dashboardOverviewBottomBlock.actualPanel,
};

export const SHOW_ALL_TEST_ID_BY_VARIANT: Record<RankBadgeVariant, string> = {
  [RankBadgeVariant.Worst]: TEST_IDS.dashboardOverviewBottomBlock.showAllWorst,
  [RankBadgeVariant.Best]: TEST_IDS.dashboardOverviewBottomBlock.showAllBest,
  [RankBadgeVariant.Actual]: TEST_IDS.dashboardOverviewBottomBlock.showAllActual,
};

export const MOBILE_ROW_HEIGHT = 54;

export const ROW_HEIGHT: Record<DashboardScope, number> = {
  [DashboardScope.Machine]: isPhone ? MOBILE_ROW_HEIGHT : 64,
  [DashboardScope.Customer]: isPhone ? MOBILE_ROW_HEIGHT : 64,
  [DashboardScope.Part]: isPhone ? MOBILE_ROW_HEIGHT : 72,
  [DashboardScope.NcFile]: isPhone ? MOBILE_ROW_HEIGHT : 72,
};

export const ROW_LAYOUT = {
  badge: {
    size: 24,
    radius: 12,
    marginHorizontal: 8,
  },
  image: {
    width: 80,
    height: 54,
    borderRadius: 6,
  },
  divider: {
    height: StyleSheet.hairlineWidth,
    color: 'Hairline/Light/No trans',
  },
  skeleton: {
    textHeight: 14,
    textRadius: 4,
    valueWidth: 60,
  },
  bar: {
    height: 14,
    borderRadius: 4,
  },
  showAllList: {
    marginTop: 10,
  },
  chevron: {
    size: 15,
  },
  name: {
    fontType: isPhone ? 'Button 1' : 'Subhead 1 bold', 
  },
  horizontalPadding: 8,
} as const;

export const BAR_MIN_RATIO = 0.04;
